import { observer } from "mobx-react-lite";
import React, { Fragment } from "react";
import {
  Button,
  Form,
  Modal,
  Space, InputNumber,
} from "antd";
import {RecordingManageStore} from "../../store";

function Update() {
  const form = Form.useFormInstance();

  const getFormData = (changeValue?: any, allValues?: any) => {
    allValues.no = RecordingManageStore.lookPower.no;
    RecordingManageStore.setLookPower({ ...allValues, ...changeValue });
  };
  const submitPower = () => {
    RecordingManageStore.updateRecording()
  };


  return (
    <Fragment>
      <Modal
          width={"520px"}
          centered
          title={RecordingManageStore.addOrUpdateModal.title}
          open={RecordingManageStore.addOrUpdateModal.isOpen}
          destroyOnClose={true}
          onCancel={() => RecordingManageStore.addOrUpdateModal.close()}
          footer={null}
      >
        <Form
            form={form}
            labelWrap
            initialValues={RecordingManageStore.lookPower}
            wrapperCol={{flex: 2}}
            onValuesChange={getFormData}
            style={{marginTop: '20px'}}
            onFinish={submitPower}
        >
          <Form.Item label="录音保存时间（天）" name="recordingRetentionDuration"  rules={[{ required: true, message: "请填写录音保存时间" }]}>
            <InputNumber min={7} max={365} style={{width:'100%'}} placeholder="请输入录音保存时间"/>
          </Form.Item>
          <Form.Item
              style={{textAlign: "right"}}
              wrapperCol={{span: 18, offset: 6}}
          >
            <Space>
              <Button
                  htmlType="reset"
                  onClick={() => RecordingManageStore.addOrUpdateModal.close()}
              >
                取消
              </Button>
              <Button type="primary" htmlType="submit">
                确定
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </Fragment>
  );
}

export default observer(Update);
